import { Box, List, Pagination, PaginationItem, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { formatDate } from '../../helpers';
import { IBuildCeremonies, IResponse } from '../../models';
import { useQuery } from 'react-query';
import { getBuildCeremonies } from '../../fetch';
import { Loader } from '../../components';

export const HomeownerCeremonies: FC = () => {
  const [recordCount, setRecordCount] = useState<number>(0);
  const { isLoading, data } = useQuery<IResponse<IBuildCeremonies[]>, Error>(
    ['buildCeremonies'],
    async () =>
      await getBuildCeremonies({
        sortBy: 'orientationDate',
        sortDirection: 'asc'
      }),
    {
      notifyOnChangeProps: 'tracked',
      onSuccess: d => {
        setRecordCount(d.totalRecordCount);
      }
    }
  );

  const [page, setPage] = useState<number>(1);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <Box
      padding="1rem"
      border="1px solid #e1e1e1"
      borderRadius="4px"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      {data?.records?.length > 0 ? (
        data?.records?.slice(page - 1, page)?.map(build => {
          return (
            <List
              key={build?.buildId}
              aria-labelledby="list-header"
              sx={{ width: '100%' }}
              subheader={
                <Typography
                  color="primary"
                  variant="h6"
                  id="list-header"
                  sx={{ marginBottom: theme => theme.spacing(0.5), textAlign: 'center' }}
                >
                  Upcoming Appointments - {build.neighborhood} - {build.lotNumber}
                </Typography>
              }
            >
              <Box
                border="1px solid #8bc640"
                borderRadius="3px"
                padding={'20px'}
                mb={1}
                display="flex"
                justifyContent="space-around"
              >
                <Typography>
                  Orientation -{' '}
                  {build.orientationDate ? formatDate(build.orientationDate) : 'Not Yet Scheduled'}
                </Typography>
              </Box>
              <Box
                border="1px solid #8bc640"
                borderRadius="3px"
                padding={'20px'}
                mb={1}
                display="flex"
                justifyContent="space-around"
              >
                <Typography>
                  Celebration -{' '}
                  {build.celebrationDate ? formatDate(build.celebrationDate) : 'Not Yet Scheduled'}
                </Typography>
              </Box>
              <Box
                border="1px solid #8bc640"
                borderRadius="3px"
                padding={'20px'}
                mb={1}
                display="flex"
                justifyContent="space-around"
              >
                <Typography>
                  Closing -{' '}
                  {build.closingDate ? formatDate(build.closingDate) : 'Not Yet Scheduled'}
                </Typography>
              </Box>
            </List>
          );
        })
      ) : isLoading ? (
        <Loader type="inline" position="centered" />
      ) : (
        <Typography
          color="primary"
          variant="h6"
          id="list-header"
          sx={{ marginBottom: theme => theme.spacing(0.5), textAlign: 'center' }}
        >
          No Upcoming Appointments
        </Typography>
      )}
      {recordCount > 1 && (
        <Pagination
          sx={{ '& .MuiTablePagination-displayedRows': { display: 'none' } }}
          renderItem={item => {
            if (item.type === 'previous' || item.type === 'next') {
              return <PaginationItem {...item} />;
            }
            return null;
          }}
          page={page}
          count={recordCount}
          onChange={handleChange}
        />
      )}
    </Box>
  );
};
